// extracted by mini-css-extract-plugin
module.exports = {"colorSelectorCounter":"ColorSelectorCounter_colorSelectorCounter__7IOUH","selected":"ColorSelectorCounter_selected__2H3QX"};